import { useState } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * useSidebarFeedback - Owns the open/close state of the feedback modal launched
 * from the AI-area sidebar, plus the sidebar block copy.
 */

type UseSidebarFeedbackReturn = {
  closeModal: () => void;
  ctaLabel: string;
  isModalOpen: boolean;
  openModal: () => void;
  promptText: string;
};

function useSidebarFeedback(): UseSidebarFeedbackReturn {
  const { t } = useTranslation(['chatbot']);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  function openModal(): void {
    setIsModalOpen(true);
  }

  function closeModal(): void {
    setIsModalOpen(false);
  }

  return {
    closeModal,
    ctaLabel: t('chatbot:sidebar_feedback_cta'),
    isModalOpen,
    openModal,
    promptText: t('chatbot:sidebar_feedback_prompt'),
  };
}

export default useSidebarFeedback;
